import * as React from "react";
import { FrequentlyAskedQuestionModel } from "../../model/autogen/FrequentlyAskedQuestionModel";
import { LinkCollectionDisplay } from "../link-collection-display";
import { RenderDocumentItemDisplay } from "./common";
import { DocumentItem } from "../../model/autogen/DocumentItem";

export function renderFAQContents(sortedItems: DocumentItem[], item: FrequentlyAskedQuestionModel) {
    return <div>
        {sortedItems.map((si) => RenderDocumentItemDisplay(si))}
        <article>
            <h3>Helpful Links</h3>
            <LinkCollectionDisplay links={item.links} />
        </article>
    </div>
}


// WEBPACK FOOTER //
// ./src/components/display/faq-display.tsx